import React from 'react'

export default class BankNone extends React.Component {


    render() {
        const { LivechatClick, methods, onChange  } = this.props
        return (
            <div className='bankNone'>
                <span />
                {
                    methods != 'LB' &&
                    <>
                        <p>ขณะนี้ธนาคารไม่สามารถให้บริการได้ กรุณาฝากช่องทางอื่น</p>
                        <p onClick={LivechatClick}>หรือติดต่อ <span>ฝ่ายบริการลูกค้า</span> เพื่อให้ความช่วยเหลือ</p>
                    </>
                }
                {
                    methods == 'LB' &&
                    <>
                        <p>ขณะนี้ธนาคาร FUN88 ไม่สามารถให้บริการได้ กรุณาฝากช่องทางอื่น</p>
                        <p>หากคุณโอนเงินแล้ว แต่ยังไม่กรอกข้อมูลการฝากเงิน โปรด</p>
                        <p><span onClick={onChange}>ระบุข้อมูลการฝากเงินที่นี่</span> หรือติดต่อ <span onClick={LivechatClick}>ฝ่ายบริการลูกค้า </span> เพื่อให้ความช่วยเหลือ</p>
                    </>
                }
            </div>
        )
    }
}
